const DEFAULTS = {
  lat: 42.107,
  lng: -72.6204
};

export { DEFAULTS };
